import {
  paginatingEndpoints
} from "./generated/paginating-endpoints.js";
import { paginatingEndpoints as paginatingEndpoints2 } from "./generated/paginating-endpoints.js";
function isPaginatingEndpoint(arg) {
  if (typeof arg === "string") {
    return paginatingEndpoints.includes(arg);
  } else {
    return false;
  }
}
export {
  isPaginatingEndpoint,
  paginatingEndpoints2 as paginatingEndpoints
};
